import { ProjectMilestoneStatus } from "@/enums";
import { IMilestone } from "@/interfaces/Project/Milestone";

export const milestoneIsClosed = (milestone: IMilestone): boolean =>
  milestone.status === ProjectMilestoneStatus.Approved ||
  milestone.status === ProjectMilestoneStatus.Released;

export const milestoneIsActive = (milestone: IMilestone): boolean =>
  milestone.status === ProjectMilestoneStatus.Draft;

export const milestoneIsSkipped = (milestone: IMilestone): boolean =>
  milestone.status === ProjectMilestoneStatus.Skipped;

export const milestoneIsInApproval = (milestone: IMilestone): boolean =>
  milestone.status === ProjectMilestoneStatus.InApproval;
